<script setup lang="ts">
import ReferenceThumb from '../thumb/ReferenceThumb.vue'
import ReferenceThumbSkeleton from '../thumb/ReferenceThumbSkeleton.vue'
import Container from '~/components/layout/Container.vue'
import { useReferencesListing } from '~/composables/api/useReferencesListing'

const referencesResponse = await useAsyncData(
  async () => {
    return await useReferencesListing()
  },
  {
    lazy: true,
    server: false,
  }
)
</script>

<template>
  <div class="c-references-listing">
    <Container>
      <h2 class="c-references-listing__title h2">
        {{ $t('pages.references.listing.title') }}
      </h2>

      <IAlert
        v-if="
          !referencesResponse.pending.value &&
          referencesResponse.data?.value?.data.length === 0
        "
        color="info"
      >
        {{ $t('pages.references.listing.empty') }}
      </IAlert>

      <div v-else class="c-references-listing__items">
        <template
          v-if="
            (!referencesResponse.data.value ||
              referencesResponse.data.value?.data.length === 0) &&
            referencesResponse.pending.value
          "
        >
          <ReferenceThumbSkeleton v-for="i in 4" :key="i" />
        </template>

        <template v-if="referencesResponse.data?.value?.data">
          <ReferenceThumb
            v-for="reference in referencesResponse.data?.value?.data"
            :key="reference.id"
            :reference="reference"
          />
        </template>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-references-listing {
  &__title {
    font-size: 58px;
    margin-bottom: 80px;
    text-align: center;

    @include breakpoint-down('md') {
      font-size: 46px;
      margin-bottom: 60px;
    }

    @include breakpoint-down('xs') {
      font-size: 38px;
      margin-bottom: 40px;
    }
  }

  &__items {
    --references-listing-top-item-margin: 80px;

    display: grid;
    gap: 90px 80px;
    grid-template-columns: repeat(2, 1fr);
    padding-top: var(--references-listing-top-item-margin);

    & > *:nth-child(odd) {
      margin-top: calc(var(--references-listing-top-item-margin) * -1);
    }

    @include breakpoint-down('xl') {
      gap: 100px;
    }

    @include breakpoint-down('lg') {
      --references-listing-top-item-margin: 55px;

      gap: 50px 40px;
    }

    @include breakpoint-down('md') {
      --references-listing-top-item-margin: 40px;

      gap: 50px 20px;
    }

    @include breakpoint-down('sm') {
      --references-listing-top-item-margin: 0;

      grid-template-columns: 1fr;
      gap: 60px;
    }
  }
}
</style>
